import React, { useState } from "react";

import { Alert, Box, CircularProgress, Grid } from "@mui/material";
import clsx from "clsx";
import { useParams } from "react-router-dom";
import mainStyles from "styles";

import { Replacement } from "@safetyculture/s12-apis-connect-web/s12/accounts/admin/v1/white_label_pb";

import { DeleteWhiteLabelReplacement } from "api/endpoints/custom-labels";
import { callOptionsHeaders } from "api/helpers";
import ConfirmDialog from "components/shared/confirm-dialog";
import { GrpcError } from "context/snackbar-context";
import { UrlParamTypes } from "types/org-display";

export interface CustomerLabelDeleteProps {
  replacement: Replacement;
  onCancel: (event: object, reason: string) => void;
  onComplete: () => void;
}

const CustomerLabelDelete = ({
  replacement,
  onCancel,
  onComplete,
}: CustomerLabelDeleteProps) => {
  const classes = mainStyles();
  useParams<UrlParamTypes>();
  const [isProcessing, setIsProcessing] = useState(false);
  const [error, setError] = useState<GrpcError>();
  const { regionCode, roleId } = useParams<UrlParamTypes>();

  const updateReplacement = async () => {
    try {
      setIsProcessing(true);
      await DeleteWhiteLabelReplacement(
        roleId,
        replacement.id,
        callOptionsHeaders(regionCode, roleId),
      );
      onComplete();
    } catch (e) {
      setError(e as GrpcError);
    } finally {
      setIsProcessing(false);
    }
  };

  const renderErrorMessage = () => {
    if (!error) {
      return;
    }
    return (
      <Alert severity="error" variant="filled" data-test-id="error-message">
        {error?.message}
      </Alert>
    );
  };

  return (
    <>
      <ConfirmDialog
        title="Edit Customer Label"
        cancelBtnLabel="Cancel"
        confirmBtnLabel="Confirm"
        open={true}
        setOpen={() => {}}
        onConfirm={() => {
          setIsProcessing(true);
          updateReplacement();
        }}
        onCancel={() => onCancel({}, "cancel")}
        disabled={isProcessing}
        disableCancelBtn={isProcessing}
      >
        {isProcessing ? (
          <Grid
            container
            justifyContent="center"
            className={clsx(classes.spaceTopSmall, classes.spaceRightMedium)}
          >
            <CircularProgress
              color="primary"
              variant="indeterminate"
              thickness={4}
              size={30}
              data-testid="loading-icon"
            />
          </Grid>
        ) : (
          <>
            <Box
              sx={{ width: "100%", paddingTop: "0.5rem" }}
              className={clsx(classes.spaceTopSmall)}
            >
              <Alert severity="info" variant="filled" style={{ margin: "2px" }}>
                You are about to delete replacement
                <p>
                  Search value: <b>{replacement.searchValue}</b>
                </p>
                <p>
                  Replace value: <b>{replacement.replaceValue}</b>
                </p>
                <p>
                  ID: <b>{replacement.id}</b>
                </p>
              </Alert>
              <p>Are you sure you want to delete the replacement?</p>
            </Box>
            <Box
              sx={{ width: "100%", paddingTop: "0.5rem" }}
              className={clsx(classes.spaceTopSmall)}
            >
              {renderErrorMessage()}
            </Box>
          </>
        )}
      </ConfirmDialog>
    </>
  );
};

export default CustomerLabelDelete;
